export default __webpack_public_path__ + "static/media/gallery_01.bdcd4824.jpg";